export default "__VITE_ASSET__DgKPFj2x__"